import { render, staticRenderFns } from "./text-speak.vue?vue&type=template&id=32da740b&scoped=true&"
import script from "./text-speak.vue?vue&type=script&lang=js&"
export * from "./text-speak.vue?vue&type=script&lang=js&"
import style0 from "./text-speak.vue?vue&type=style&index=0&id=32da740b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da740b",
  null
  
)

export default component.exports